'use client'

import { useTranslation } from '@shared/config/i18n'
import { UI_IDS } from '@shared/constants'
import { clsx } from 'clsx'

import { ButtonV1, Typography } from '@podo-app/design-system-temp'

type ButtonProps = Parameters<typeof ButtonV1>[0]

type Props = {
  className?: string
} & ButtonProps

const GoogleLoginButton = ({ className, ...props }: Props) => {
  const t = useTranslation()

  return (
    <ButtonV1
      size="xLarge"
      className={clsx(
        'google_login_btn',
        'py-2.5 text-gray-900 rounded-[7.5px] flex items-center justify-center gap-[5px] w-full bg-white hover:bg-gray-50 border border-gray-200',
        className,
      )}
      eventParams={{ name: UI_IDS.btn.googleLogin, location: 'login', action: 'submit' }}
      {...props}
    >
      <span
        aria-hidden
        className="inline-flex size-6 items-center justify-center text-[24px] font-bold leading-none text-[#4285F4]"
      >
        G
      </span>
      <Typography size="h3">{t('common.auth.googleLogin')}</Typography>
    </ButtonV1>
  )
}

export default GoogleLoginButton
